<template>
	<div
		v-if="showPopUp"
		class="z-50 relative flex"
		data-testid="product-gallery-popup"
	>
		<div
			class="flex w-[100vw] h-[100vh] fixed bg-white z-50 lg:center-box-fixed shadow-md top-0 left-0"
		>
			<div class="flex relative items-center overflow-hidden lg:max-w-[100vw]">
				<div
					class="absolute z-50 right-4 top-4 flex cursor-pointer"
					@click="closeModal()"
				>
					<XMarkIcon :class="[`h-6 w-6 text-primary`]" />
				</div>
				<BigPicture
					:images="images"
					:big-image-index="bigImageIndex"
					:increase-big-image-index="increaseBigImageIndex"
					:decrease-big-image-index="decreaseBigImageIndex"
					size="full"
					:show-pop-up="showPopUp"
				/>
			</div>
		</div>
		<div class="h-[100vh] w-[100vw] bg-gray-dark center-box-fixed"></div>
	</div>
</template>

<script setup lang="ts">
import { XMarkIcon } from "@heroicons/vue/24/outline";
import type { CategoryFiles } from "@nwt/norce-pwa/dist/runtime/types/api/category/category";
import type { FilteredProductItemFiles } from "@nwt/norce-pwa/dist/runtime/types/api/searchAndFilter/filters";
import type { ProductFile } from "@nwt/norce-pwa/dist/runtime/types/api/product/product";
import type {
	BigImageIndex,
	SetShowPopUp
} from "~/types/storyblok/imageGallery/imageGallery";
import BigPicture from "./BigPicture.vue";

interface Props {
	images: ProductFile[] | CategoryFiles[] | FilteredProductItemFiles[];
	bigImageIndex: number;
	decreaseBigImageIndex: BigImageIndex;
	increaseBigImageIndex: BigImageIndex;
	showPopUp?: boolean;
	setShowPopUp: SetShowPopUp;
}

const {
	images,
	bigImageIndex,
	decreaseBigImageIndex,
	increaseBigImageIndex,
	showPopUp,
	setShowPopUp
} = defineProps<Props>();

const resetPopupAndScroll = () => {
	setShowPopUp(false);
	const body = document.getElementsByTagName("body")[0];

	if (body) {
		body.style.overflow = "";
	}
};

const closePopUpOnEscape = (e: KeyboardEvent) => {
	if (e.key == "Escape") {
		resetPopupAndScroll();
	}
};

const closeModal = () => {
	resetPopupAndScroll();
};

onMounted(() => {
	window.addEventListener("keydown", closePopUpOnEscape);
});
</script>
